import React from 'react';

import CalculatorCore, {Props} from './CalculatorCore';
import SubjectWithLetterScore from './SubjectWithLetterScore';
import {LetterGrade} from '../constants';

const LETTER_OPTIONS: ReadonlyArray<LetterGrade> = [
  LetterGrade.APlusPlus,
  LetterGrade.APlus,
  LetterGrade.A,
  LetterGrade.AMinus,
  LetterGrade.BPlus,
  LetterGrade.B,
  LetterGrade.BMinus,
  LetterGrade.CPlus,
  LetterGrade.C,
  LetterGrade.CMinus,
  LetterGrade.DPlus,
  LetterGrade.D,
  LetterGrade.DMinus,
  LetterGrade.EPlus,
  LetterGrade.E,
  LetterGrade.EMinus,
];

export default function CalculatorSACE(props: Props) {
  return (
    <CalculatorCore
      {...props}
      subjectRenderer={subject => (
        <SubjectWithLetterScore
          subject={subject}
          letterOptions={LETTER_OPTIONS}
          onDeleteSubject={props.onDeleteSubject}
          onUpdateSubject={props.onUpdateSubject}
        />
      )}
    />
  );
}
